/**
 * Copyright 2022-2026 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import {
  Box,
  Tab,
  Tabs as TabContainer,
  theme,
  Text,
  Heading,
} from "@nordcloud/gnui";
import { StyledTab } from "~/components/Styled/Tabs";
import { useTabStepNavigation } from "~/hooks";
import { MetadataTab } from "./MetadataTab/MetadataTab";
import { PlansTab } from "./PlansTab";
import { ResourcesTab } from "./ResourcesTab/ResourcesTab";

type Props = {
  resourceGroupId: string;
};

const TAB_STEP_MAPPING: Record<string, number> = {
  resources: 0,
  plans: 1,
  metadata: 2,
};

export function Tabs({ resourceGroupId }: Props) {
  const { currentStep, handleTab } = useTabStepNavigation(TAB_STEP_MAPPING);

  return (
    <Box spacing="spacing02" css={{ padding: 0 }}>
      <TabContainer step={currentStep} handleTab={handleTab}>
        <StyledTab heading="Resources">
          <Heading level={4}>List of Group Resources</Heading>
          <Text size="sm" color={theme.color.text.text02}>
            These are resources in the resource group. To edit the resource
            group, click{" "}
            <Text size="sm" as="span" weight="medium">
              Edit Group
            </Text>
          </Text>
          <ResourcesTab />
        </StyledTab>
        <Tab heading="Plans">
          <Heading level={4}>Plans</Heading>
          <Text size="sm" color={theme.color.text.text02}>
            List of plans where resource group is used.
          </Text>
          <PlansTab resourceGroupId={resourceGroupId} />
        </Tab>
        <Tab heading="Metadata">
          <MetadataTab />
        </Tab>
      </TabContainer>
    </Box>
  );
}
